import * as React from 'react';

const Previous = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.1998 7.80005L10.1109 13L18.1998 18.2V7.80005ZM10.1109 13V7.80005H7.7998V18.2H10.1109V13Z"
      fill="#63606E"
    />
  </svg>
);
export default Previous;
